import { defineComponent as _defineComponent } from 'vue'
import useStore from '@/utils/store/common';
import { computed, onMounted, ref } from 'vue';
import Header from './components/Header/Header.vue';
import PermissionsList from './components/PermissionsList/PermissionsList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Right',
  props: {
  role: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['save'],
  setup(__props, { emit }) {

const props = __props;





const needReload = ref(false);

const permissions = ref([]);

const store = useStore();

const getPermissionsFeatures = computed(() => store.getters['userRoles/getPermissionsFeatures']);

const getEdition = computed(() => store.getters['userRoles/getEdition']);

onMounted(() => {
  store.dispatch('userRoles/fetchPermissionsFeatures');
});

function reload() {
  needReload.value = true;
}

function handleSave(event: any) {
  const dataToSend = event;
  dataToSend.permissions = permissions.value;
  store.dispatch('userRoles/updatePermissionsFeaturesOfRole', dataToSend).then(() => {
    emit('save', dataToSend);
  });
}

return { __sfc: true,props, emit, needReload, permissions, store, getPermissionsFeatures, getEdition, reload, handleSave, Header, PermissionsList }
}

})